module.exports = __webpack_public_path__ + "img/completed.26c695b6.svg";